import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request to add new headers
        const excludedUrls = ['search/member'];
        const onlyProdUrls = ['/realms/lokos/permission'];
        if(req.url.includes(excludedUrls[0])) {
            return next.handle(req);
        }
        const isProdUrl = onlyProdUrls.some(url => req.url.includes(url));
        let clonedRequest = null;
        if (isProdUrl) {
            // If the URL matches, add the Ocp-Apim-Subscription-Key header
            clonedRequest = req.clone({
                setHeaders: {
                    'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionKeyProd,
                },
            });
        } else {
            clonedRequest = req.clone({
                setHeaders: {
                    'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionKey, // Example header
                },
            });
        }

        // Pass the modified request to the next handler
        return next.handle(clonedRequest);
    }
}